import React from "react"
import { LinearProgress } from "material-ui"
import strings from "../../localization/strings"
import * as utils from "../../helpers/utils"
import { IFreeAccountMetricsData } from "../../models"

interface IProps {
    showInSubscriptionDrawer?: boolean
    data: IFreeAccountMetricsData
}

const FreeAccountDataUsageLinearProgress: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            <MetricsLinear
                label={strings.Punches}
                count={props.data.PunchCount}
                showInSubscriptionDrawer={props.showInSubscriptionDrawer}
                limit={1000}
            />
            <MetricsLinear
                label={strings.Jobs}
                count={props.data.JobCount}
                showInSubscriptionDrawer={props.showInSubscriptionDrawer}
                limit={10}
            />
            <MetricsLinear
                label={strings.Employees}
                count={props.data.EmployeeCount}
                showInSubscriptionDrawer={props.showInSubscriptionDrawer}
                limit={100}
            />
            <MetricsLinear
                label={strings.Clients}
                count={props.data.ClientCount}
                showInSubscriptionDrawer={props.showInSubscriptionDrawer}
                limit={10}
            />
        </div>
    )
}

export default FreeAccountDataUsageLinearProgress

interface IMetricsLinearProps {
    showInSubscriptionDrawer?: boolean
    label: string
    count: number
    limit: number
}
const MetricsLinear: React.SFC<IMetricsLinearProps> = (props: IMetricsLinearProps) => {
    let percent = utils.roundToTwo(props.count * 100 / props.limit)
    percent = percent > 100 ? 100 : percent
    return (
        <div style={{ marginTop: props.showInSubscriptionDrawer ? -2 : 5 }}>
            <div>{props.label}</div>
            <div style={{ display: "flex" }}>
                <LinearProgress mode="determinate" style={{ width: 165 }} value={percent} />
                <div style={{ marginLeft: 5, marginTop: -9, width: 35 }}>
                    {props.showInSubscriptionDrawer ? `${props.count}/${props.limit}` : `${percent}%`}
                </div>
            </div>
        </div>
    )
}

